import { ConnectorsSortingStrategy } from './types/client';

const {
  DEV,
  PROD,
  MODE,
  VITE_ENV,
  VITE_WEBSOCKETS_PROTOCOL,
  VITE_API_PROTOCOL,
  VITE_API_HOST,
  VITE_SENTRY_DNS_KEY,
  VITE_GOOGLE_MAPS_API_KEY,
  VITE_PLAY_STORE_LINK,
  VITE_APP_STORE_LINK,
  VITE_AZURE_CLIENT_ID,
  VITE_AZURE_TENANT_ID,
  VITE_AZURE_REDIRECT_URI,
  VITE_CONNECTORS_SORTING_STRATEGY,
  VITE_AMPLITUDE_EVX_API_KEY,
  VITE_LOG_LEVEL,
  VITE_SENTRY_LOG_LEVEL,
  VITE_ENABLE_TENANT_LOGGING,
} = import.meta.env;

const STAGE = MODE === 'test' ? 'development' : VITE_ENV;
const SENTRY_DNS_KEY = VITE_SENTRY_DNS_KEY;
const GOOGLE_MAPS_API_KEY = VITE_GOOGLE_MAPS_API_KEY;
const AMPLITUDE_EVX_API_KEY = VITE_AMPLITUDE_EVX_API_KEY;

const WEBSOCKETS_PROTOCOL = DEV ? VITE_WEBSOCKETS_PROTOCOL : 'wss';
const API_PROTOCOL = DEV ? VITE_API_PROTOCOL : 'https';
const API_HOST = VITE_API_HOST;

const PLAY_STORE_LINK = VITE_PLAY_STORE_LINK;
const APP_STORE_LINK = VITE_APP_STORE_LINK;

const AZURE_CLIENT_ID = VITE_AZURE_CLIENT_ID;
const AZURE_TENANT_ID = VITE_AZURE_TENANT_ID;
const AZURE_REDIRECT_URI = VITE_AZURE_REDIRECT_URI;
const LOG_LEVEL = VITE_LOG_LEVEL;
const ENABLE_TENANT_LOGGING = VITE_ENABLE_TENANT_LOGGING === 'true';

const CONNECTORS_SORTING_STRATEGY = VITE_CONNECTORS_SORTING_STRATEGY
  ? (VITE_CONNECTORS_SORTING_STRATEGY as ConnectorsSortingStrategy)
  : ConnectorsSortingStrategy.ALPHABETICAL;

export {
  API_HOST,
  API_PROTOCOL,
  APP_STORE_LINK,
  AZURE_CLIENT_ID,
  AZURE_REDIRECT_URI,
  AZURE_TENANT_ID,
  DEV,
  GOOGLE_MAPS_API_KEY,
  MODE,
  PLAY_STORE_LINK,
  PROD,
  SENTRY_DNS_KEY,
  STAGE,
  CONNECTORS_SORTING_STRATEGY,
  WEBSOCKETS_PROTOCOL,
  AMPLITUDE_EVX_API_KEY,
  LOG_LEVEL,
  VITE_SENTRY_LOG_LEVEL as SENTRY_LOG_LEVEL,
  ENABLE_TENANT_LOGGING,
};
